import React from 'react';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-image">
          <img src="/images/ac_photo.png" alt="About Me" />
        </div>
        <div className="about-content">
          <h1 className="hello">Hello, I'm</h1>
          <h2 className="hello">Anjali Chaudhary</h2>
          <p className="tagline" style={{ fontSize: '30px' }}>
          I am a dedicated Computer Science student hailing from India, committed to cultivating my expertise in technology and product development.</p>

        </div>
      </div>
    </section>
  );
};

export default About;
